export class ParseError extends Error {
  constructor(
    source: string,
    public cause: Error,
  ) {
    super(`Ошибочный формат данных в ${source}`);
    this.name = "ParseError";
  }
}

export const dataParser = <T>(fn: () => T, source: string): T => {
  try {
    return fn();
  } catch (cause) {
    throw new ParseError(source, cause);
  }
};
